import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { forwardRef, memo, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { Card, Steps, Tabs, Text } from '@beef/ui-kit';
import { Picture } from '@beef/smart-kit';
import { withAnalyticsSteps } from "../../hocs";
import { Title } from "../Title";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
var _ExtendedSteps = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _currentContent$steps, _currentContent$steps3, _currentStep$img;
  var title = _ref.title,
    transitionTime = _ref.transitionTime,
    text = _ref.text,
    _ref$tabs = _ref.tabs,
    tabs = _ref$tabs === void 0 ? [] : _ref$tabs,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? [] : _ref$content,
    onClick = _ref.onClick,
    defaultTab = _ref.defaultTab,
    meta = _ref.meta;
  var _useState = useState(function () {
      return defaultTab ? (tabs === null || tabs === void 0 ? void 0 : tabs.find(function (tab) {
        return tab.id === defaultTab;
      })) || tabs[0] : tabs[0];
    }),
    _useState2 = _slicedToArray(_useState, 2),
    currentTab = _useState2[0],
    setCurrentTab = _useState2[1];
  var _useState3 = useState(content[0]),
    _useState4 = _slicedToArray(_useState3, 2),
    currentContent = _useState4[0],
    setCurrentContent = _useState4[1];
  var _useState5 = useState(currentContent === null || currentContent === void 0 ? void 0 : (_currentContent$steps = currentContent.steps) === null || _currentContent$steps === void 0 ? void 0 : _currentContent$steps[0]),
    _useState6 = _slicedToArray(_useState5, 2),
    currentStep = _useState6[0],
    setCurrentStep = _useState6[1];
  useEffect(function () {
    var _checkedContent, _checkedContent$steps;
    var checkedContent = content[0];
    if (currentTab !== null && currentTab !== void 0 && currentTab.id) {
      checkedContent = content.find(function (item) {
        return item.tabId === currentTab.id;
      });
    }
    setCurrentContent(checkedContent);
    setCurrentStep((_checkedContent = checkedContent) === null || _checkedContent === void 0 ? void 0 : (_checkedContent$steps = _checkedContent.steps) === null || _checkedContent$steps === void 0 ? void 0 : _checkedContent$steps[0]);
  }, [content, currentTab]);
  var handleChangeTab = useCallback(function (id) {
    if (id !== (currentTab === null || currentTab === void 0 ? void 0 : currentTab.id)) {
      setCurrentTab(tabs.find(function (tab) {
        return tab.id === id;
      }));
      if (onClick) {
        onClick({
          tabId: id,
          stepId: ''
        });
      }
    }
  }, [currentTab === null || currentTab === void 0 ? void 0 : currentTab.id, tabs, onClick]);
  var handleStep = function handleStep(id) {
    if (id !== (currentStep === null || currentStep === void 0 ? void 0 : currentStep.id)) {
      var _currentContent$steps2;
      setCurrentStep(currentContent === null || currentContent === void 0 ? void 0 : (_currentContent$steps2 = currentContent.steps) === null || _currentContent$steps2 === void 0 ? void 0 : _currentContent$steps2.find(function (step) {
        return step.id === id;
      }));
      if (onClick) {
        onClick({
          tabId: '',
          stepId: id
        });
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper'),
    itemScope: true,
    itemType: "https://schema.org/HowTo",
    ref: ref,
    "data-t-id": "components-ExtendedSteps"
  }, title && /*#__PURE__*/React.createElement(Title, {
    className: cx(text ? 'title-with-subtitle' : 'wrapper__block--title'),
    extraAttributes: {
      itemProp: 'name'
    }
  }, title), !!(meta !== null && meta !== void 0 && meta.length) && meta.map(function (item) {
    return /*#__PURE__*/React.createElement("meta", {
      content: item.content,
      itemProp: item.itemProp,
      key: item.content
    });
  }), text && /*#__PURE__*/React.createElement(Text, {
    className: cx('wrapper__block--text'),
    color: "grey95",
    size: "size4-r",
    tagType: "p"
  }, text), (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: cx('tabs')
  }, /*#__PURE__*/React.createElement(Tabs, {
    isScrollable: true,
    noWrap: true,
    onChange: handleChangeTab,
    selectedTab: currentTab === null || currentTab === void 0 ? void 0 : currentTab.id,
    tabs: tabs,
    variant: "secondary"
  })), !!(currentContent !== null && currentContent !== void 0 && (_currentContent$steps3 = currentContent.steps) !== null && _currentContent$steps3 !== void 0 && _currentContent$steps3.length) && /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper__block--steps')
  }, /*#__PURE__*/React.createElement(Steps, {
    isClickable: currentContent.isClickableSteps,
    items: currentContent.steps,
    onChange: handleStep,
    selectedStep: (currentStep === null || currentStep === void 0 ? void 0 : currentStep.id) || currentContent.steps[0].id,
    transitionTime: transitionTime
  }), currentContent.actionPanel && /*#__PURE__*/React.createElement("div", {
    className: cx('action-panel')
  }, currentContent.actionPanel)), (currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$img = currentStep.img) === null || _currentStep$img === void 0 ? void 0 : _currentStep$img.src) && /*#__PURE__*/React.createElement(Card, {
    bordered: false,
    className: cx('wrapper__block--contents')
  }, /*#__PURE__*/React.createElement(Picture, _extends({
    className: cx('wrapper__image')
  }, currentStep === null || currentStep === void 0 ? void 0 : currentStep.img, {
    "data-t-id": "components-ExtendedSteps"
  }))));
});
export var ExtendedSteps = withAnalyticsSteps( /*#__PURE__*/memo(_ExtendedSteps));